export default "__VITE_ASSET__wNMGZcsx__"